module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "container"
    }
  }, [_c('router-view', {
    attrs: {
      "id": "view"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd26cd6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 259
// module chunks = 3